import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { getSortableDate, getSortableTime } from 'src/app/utlis';

@Component({
  selector: 'app-view-all-v2',
  templateUrl: './view-all-v2.component.html',
  styleUrls: ['./view-all-v2.component.scss'],
})
export class ViewAllV2Component implements OnInit, AfterViewInit, OnDestroy {
  apptId: any;
  appointmentStatus: any;
  isApptCompleted: boolean = false;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  constructor(
    public datepipe: DatePipe,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private appointmentService: AppointmentService,
    private authenticationService: AuthenticationService,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  value: String = 'Upcoming';
  appointments: any = [];

  appointmentsv2: any = [];
  userRole: any;
  status!: string;
  filterForm!: FormGroup;
  tests: any;
  surveys: any;
  selectedTests: any;
  selectedSurveys: any;
  disabledButton: boolean = false;
  show: boolean = true;
  schedules: any;
  page = 4;

  ngAfterViewInit(): void {
    this.dtTrigger.next(this);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  rerender() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(this);
    });
  }

  ngOnInit(): void {
    let location = null;
    let diagId = null;
    this.status = 'ALL';
    this.show = false;
    jQuery('.modal-backdrop.fade.show').remove();
    this.spinner.show();

    this.userRole = this.authService.getUserType();
    if (this.userRole != 'ADMIN' && this.userRole != 'DIRECTOR') {
      diagId = this.authenticationService.getUserId();
    }

    //this.show = true;

    this.filterForm = this.formBuilder.group(
      {
        fromDate: [],
        toDate: [],
      },
      { validator: this.dateLessThan('fromDate', 'toDate') }
    );

    //this.loadDashbaord(diagId, location);
    this.loadDashbaordv2(diagId, location);
  }

  addDays(date: Date, days: number): Date {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  loadDashbaord(diagId: any, location: any) {
    this.appointmentService
      .getAppointments(location, diagId, this.status, null, null, null)
      .subscribe((res: any) => {
        this.appointments = res.data;
        this.spinner.hide();
        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,
          stateSave: true,
          lengthMenu: [
            [50, 100, 150, -1],
            [50, 100, 150, 'All'],
          ],
          processing: true,
          destroy: true,
          searching: true,
        };
        this.show = true;
        if (this.appointments != null && this.appointments.length > 0) {
          this.appointments = this.appointments.sort((a: any, b: any) =>
            new Date(a.appointmentDetails.schedules[0].appointmentDate) <=
            new Date(b.appointmentDetails.schedules[0].appointmentDate)
              ? -1
              : 1
          );
        }
        this.rerender();
      });
  }

  loadDashbaordv2(diagId: any, location: any) {
    let newDateAfter30 = this.addDays(new Date(), 30);
    const yesterday = this.addDays(new Date(), -1);
    let startDate = this.datepipe.transform(yesterday, 'yyyy-MM-dd');
    let endDate = this.datepipe.transform(newDateAfter30, 'yyyy-MM-dd');

    this.appointmentService
      .getAppointmentsV2(
        location,
        diagId,
        this.status,
        null,
        null,
        null,
        'Appointment'
      )
      .subscribe((res: any) => {
        //this.appointmentService.getAppointmentsV2(location, diagId, this.status, null, null, null,'Appointment').subscribe((res: any) => {
        this.appointmentsv2 = res.data;
        this.spinner.hide();
        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,

          lengthMenu: [
            [10, 20, 30, -1],
            [10, 20, 30, 'All'],
          ],
          processing: true,
          destroy: true,
          searching: true,
          order: [[]],
        };
        this.show = true;
        if (this.appointmentsv2 != null && this.appointmentsv2.length > 0) {
          this.appointmentsv2 = this.appointmentsv2.sort(
            (a: any, b: any) =>
              new Date(b.appointmentDate).getTime() -
              new Date(a.appointmentDate).getTime()
          );
        }

        this.rerender();
      });
  }

  dateLessThan(from: string, to: string) {
    return (group: FormGroup): { [key: string]: any } => {
      let f = group.controls[from];
      let t = group.controls[to];
      if (f.value && t.value && f.value > t.value) {
        return {
          dates: 'To Date should be greater than From Date',
        };
      }
      return {};
    };
  }

  submitFilterFormV2() {
    this.spinner.show();
    this.appointmentService
      .getAppointmentsV2(
        null,
        null,
        'ALL',
        null,
        this.filterForm.controls['fromDate'].value,
        this.filterForm.controls['toDate'].value,
        'Appointment'
      )
      .subscribe((res: any) => {
        this.appointmentsv2 = res.data;
        if (this.appointmentsv2.length > 0) {
          this.appointmentsv2 = this.appointmentsv2.sort(
            (a: any, b: any) =>
              new Date(b.appointmentDate).getTime() -
              new Date(a.appointmentDate).getTime()
          );

          this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            stateSave: true,
            lengthMenu: [
              [50, 100, 150, -1],
              [50, 100, 150, 'All'],
            ],
            processing: true,
            destroy: true,
            searching: true,

            order: [[]],
          };

          this.rerender();
        } else {
          this.rerender();
        }
        this.show = true;
        this.spinner.hide();
      });
  }

  submitFilterForm() {
    this.spinner.show();
    this.appointmentService
      .getAppointments(
        null,
        null,
        'ALL',
        null,
        this.filterForm.controls['fromDate'].value,
        this.filterForm.controls['toDate'].value
      )
      .subscribe((res: any) => {
        this.appointments = res.data;
        if (this.appointments.length > 0) {
          this.appointments = this.appointments.sort(
            (a: any, b: any) =>
              new Date(
                b.appointmentDetails.schedules[0].appointmentDate
              ).getTime() -
              new Date(
                a.appointmentDetails.schedules[0].appointmentDate
              ).getTime()
          );

          this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            stateSave: true,
            lengthMenu: [
              [50, 100, 150, -1],
              [50, 100, 150, 'All'],
            ],
            processing: true,
            destroy: true,
            searching: true,
          };

          this.rerender();
        }
        this.show = true;
        this.spinner.hide();
      });
  }

  getAppointments() {}
  selectValue(value: string) {
    this.value = value;
  }
  setApptId(apptId: any, apptStatus: any) {
    this.isApptCompleted = false;

    if (apptStatus == 'COMPLETE' || apptStatus == 'CANCEL') {
      this.isApptCompleted = true;
    }

    this.apptId = apptId;
  }
  getTestTypes() {}
  addSurveys() {
    var surveys = this.surveys.surveysList
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedSurveys = surveys;

    var tests = this.surveys.testsList
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedTests = tests;

    let selectedDetails = {
      tests: this.selectedTests,
      surveys: this.selectedSurveys,
      appointmentId: this.apptId,
    };
    this.appointmentService
      .saveSurveyDetails(selectedDetails)
      .subscribe((res) => {
        location.reload();
      });
  }
  disableButton() {}

  getSortableTime(timeRangeStr: string) {
    return getSortableTime(timeRangeStr);
  }

  getSortableDate(dateStr: string): string {
    return getSortableDate(dateStr);
  }
}
